import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { NativePdfPreviewState } from 'owa-sxsdata';

export interface NativePdfPreviewProps {
    className?: string;
    onLoad: () => void;
    viewState: NativePdfPreviewState;
}

const styles = require('./NativePdfPreview.scss');
const classNames = require('classnames/bind').bind(styles);

export default observer(function NativePdfPreview(props: NativePdfPreviewProps) {
    const previousPreviewUrl = React.useRef<string>(null);
    if (previousPreviewUrl.current !== props.viewState.previewUrl) {
        previousPreviewUrl.current = props.viewState.previewUrl;
        window.requestAnimationFrame(props.onLoad);
    }
    // use key in <object> to force recreation of the corresponding DOM
    // element if the url changes (required for Edge browser)
    return (
        <div className={classNames(props.className, styles.main)}>
            <object
                key={props.viewState.previewUrl}
                className={styles.object}
                data={props.viewState.previewUrl}
                type={props.viewState.mediaType}
            />
        </div>
    );
});
